export default "__VITE_ASSET__4196c0a7__"